module.exports = __webpack_public_path__ + "static/img/mb1.4cf4a3d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/mb1.jpg
// module id = viC5
// module chunks = 1